var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99871 5.14855C9.99903 5.34715 9.94104 5.5396 9.83479 5.69252C9.71395 5.86634 9.54008 5.97568 9.35155 5.99641C9.16302 6.01714 8.97532 5.94755 8.82987 5.80301L5.00977 1.99524L1.18255 5.66702C1.03531 5.80962 0.84648 5.87634 0.657869 5.85241C0.469257 5.82848 0.296425 5.71588 0.177636 5.53953C0.0464702 5.36175 -0.0165587 5.12677 0.00373483 4.89121C0.0240284 4.65565 0.125804 4.44087 0.284541 4.2986L4.56077 0.193353C4.82376 -0.0644512 5.20292 -0.0644512 5.46591 0.193353L9.74213 4.4431C9.91706 4.61603 10.0124 4.87807 9.99871 5.14855Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.501eb4f72a091db570994d137bb91bba.svg";
export { ForwardRef as ReactComponent };